module.exports = __webpack_public_path__ + "img/06.1a15a97a.png";